const MEASUREMENT_FIELDS = ['height', 'weight', 'chest', 'waist', 'hips', 'inseam', 'shoulder', 'sleeve', 'neck', 'shoeSize']
const ADDRESS_FIELDS = ['address', 'city', 'state', 'zipCode', 'country']
const PROFILE_FIELDS = [
  'name',
  'communityName',
  'firstName',
  'lastName',
  'photoURL',
  'age',
  'gender',
  'stylePreferences',
  'favoriteColors',
  'budget',
  'occasion'
]

function pick(source, fields) {
  const out = {}
  for (const field of fields) {
    if (source?.[field] !== undefined) out[field] = source[field]
  }
  return out
}

/**
 * The Settings "Download my data" file. Orders are limited to the customer's own,
 * so an admin export never includes other customers.
 */
export function buildDataExport({
  user,
  preferences = null,
  favorites = [],
  orders = [],
  customQuotes = [],
  communityPosts = [],
  unavailable = [],
  now = new Date()
}) {
  const uid = user?.uid || null
  return {
    exportedAt: now.toISOString(),
    account: user
      ? {
          email: user.email,
          name: user.name,
          subscription: user.subscription,
          provider: user.provider,
          createdAt: user.createdAt,
          upgradedAt: user.upgradedAt
        }
      : null,
    profile: user ? pick(user, PROFILE_FIELDS) : null,
    phone: user?.phone ?? null,
    address: user ? pick(user, ADDRESS_FIELDS) : null,
    measurements: user ? pick(user, MEASUREMENT_FIELDS) : null,
    preferences,
    designs: user?.designs || [],
    favorites,
    orders: orders.filter((order) => uid && order?.userId === uid),
    customQuotes: customQuotes.filter((quote) => uid && quote?.userId === uid),
    communityPosts: communityPosts.filter((post) => uid && post?.userId === uid),
    ...(unavailable.length ? { incomplete: unavailable } : {})
  }
}
